// import { maybe, getWith } from "./functions"

export const makeType = proto => {
  // this is the constructor
  const f = function(args) {
    const obj = Object.create(proto)
    if (typeof obj.initialize === "function") {
      // console.log(`initializing:`, {
      //   ...obj
      // })
      obj.initialize(args)
    }

    return obj
  }
  // console.log(`types: f:`, f)

  Object.entries(proto).forEach(([key, value]) => {
    // console.log(`makeType: adding ${key} from proto to`, {
    //   ...f
    // })

    if (typeof value === "string") {
      if (key === "name") {
        key = "className"
      }
      Object.defineProperty(f, key, {
        value: value,
        writable: true,
        enumerable: true,
        configurable: true
      })
      // } else {
      //   console.log(`not adding to type: ${key}`, value)
    }
  })

  f.prototype.toString = () => {
    console.log(`className:`, typeof f.className)
    const name = f.className
    return `${name} {}`
  }

  // console.log(`mixed object:`, {
  //   ...f
  // })
  return f
}

// export function makeType(proto) {
//     // this is the constructor
//     const f = function(name, options) {
//       const obj = Object.create(proto);
//       if (typeof obj.initialize !== "undefined") {
//         obj.initialize(name, options);
//       }
//       // obj.name = proto.name;
//       return obj;
//     };

//     f.proto = proto;
//     // this just makes the constructor look more class-like
//     f.prototype = Object.create(proto);
//     f.prototype.constructor = f;
//     // f.prototype.name = proto.name;

//     Object.keys(proto).forEach(k => {
//       if (typeof proto[k] === "string") {
//         // redefining "name" causes a crash in old webkit browsers (Safari < 10)
//         const val = proto[k];
//         if (k === "name") {
//           k = "className";
//         }
//         Object.defineProperty(f, k, {
//           value: val,
//           writable: true,
//           enumerable: true,
//           configurable: true
//         });
//       }
//     });

//     f.prototype.toString = function() {
//       let name = f.className;
//       if (!name && f.proto) {
//         name = f.proto.name;
//       }
//       return `${name} {}`;
//     }

//     if (typeof f.initialize !== "undefined") {
//       f.initialize(name, options);
//     }

//     return f;
//   };

// export const compose = (type, proto) =>
//     maybe(type_proto => {
//         const newProto = {
//             ...type_proto,
//             ...proto
//         };

//         return makeType(newProto);
//     })(type.proto);